import { ReactElement } from 'react'
import styled from '@emotion/styled'
import { Button, darken } from '@mui/material'
import { colors } from '@global/constants'

const StyledContainedButton = styled(Button)`
  color: ${colors.white};
  background-color: ${colors.brand.primary};

  &:hover {
    background-color: ${darken(colors.brand.primary, 0.3)};
  }
`

const StyledButton = styled(Button)`
  color: ${colors.brand.primary};
  border: 1px solid rgba(48, 80, 90, 0.5);
`

interface Props {
  contained?: boolean
  children: string | ReactElement | (ReactElement | string)[]
  [x: string]: any
}

export const DarkButton = ({ contained, children, ...props }: Props) => {
  return contained ? (
    <StyledContainedButton variant="contained" {...props}>
      {children}
    </StyledContainedButton>
  ) : (
    <StyledButton {...props}>{children}</StyledButton>
  )
}
